import React, { useContext, useState } from 'react';
import Navigation from "../../router/Navigation";
import { GlobalContext } from '../../context/GlobalContext';
import LanguageSelector from '../common/LanguageSelector';
import { useCartContext } from '../../context/CartContext';
import { useTranslation } from 'react-i18next';
import Modal from '../common/Modal';

const Header = ({ currentStep }) => {
  const { store, goToStep, step } = useContext(GlobalContext);
  const { cart } = useCartContext();
  const { t } = useTranslation();
  const [modalVisible, setModalVisible] = useState(false);
  const cartCount = cart.items?.length || 0;

  const handleStepClick = () => {
    if (!cart.items || cart.items.length === 0) {
      setModalVisible(true);
      return;
    }
    if (!window.location.pathname.includes("/home")) {
      window.location.href = "/home";
    }
    goToStep(2);
  };

  const handleCloseModal = () => {
    setModalVisible(false);
  };

  const handleAutreCarteModal = () => {
    setModalVisible(false);
    goToStep(1);
  };

  const handleValiderAchat = () => {
    setModalVisible(false);
    goToStep(2);
  };

  return (
    <header id="header">
      <h1 className="visually-hidden">Cartes Cadeaux</h1>
      <div className="wrapper">
        <div id="logo" className="logo">
          <a href={store.site} aria-label={`Retour au site ${store.name || 'du magasin'}`}>
            <img src={store.logo} alt={store.name || 'Magasin'} />
          </a>
        </div>
        <Navigation
          currentStep={step}
          onStepChange={goToStep}
        />
        <div id="cartBox">
          <a
            href="#"
            tabIndex="0"
            onClick={(e) => {
              e.preventDefault();
              handleStepClick()
            }
            }
            role="button"
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault(); // Empêche le défilement avec la barre d'espace
                handleStepClick();
              }
            }}
          >
            <i className="icon-panier" aria-hidden="true"></i>
            <span className="cartText">{t("Panier")}</span>
            <span className="countPanier bgSecondColor" aria-label={`${cartCount} ${cartCount === 1 ? t("article") : t("articles")}`}>{cartCount}</span>
          </a>
        </div>
        {store.languages && store.languages.length > 1 && (
          <LanguageSelector
            options={store.languages}
            displayFlag={store.display_language_flag}
            defaultLanguage={store.default_language}
          />
        )}
      </div>
      {modalVisible && (
        <Modal
          modalType="cart"
          onHideModal={handleCloseModal}
          onAutreCarteModal={handleAutreCarteModal}
          onValiderAchat={handleValiderAchat}
          store={store}
        />
      )}
    </header>
  );
};

export default Header;